import { useOutletContext } from 'react-router-dom';
import { DataAccessContext } from './types';

export const useDataAccessContext = (): DataAccessContext => {
  return useOutletContext<DataAccessContext>();
};
